// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3ZjUG","inputWrap":"CustomTip_inputWrap__BGHxi"};